import { featureCollection } from '@turf/turf'
import { Layer, Source } from 'react-map-gl/dist/es5'
import { useGeometryEditorStateContext } from '..'
import { useOtherFieldStyles } from './useOtherFieldStyles'

export const OtherFieldsLayer = () => {
  const { editorOverlaps, fieldShapes, fieldPoints } = useGeometryEditorStateContext()
  const FIELD_STYLE = useOtherFieldStyles()

  return (
    <>
      <Source
        id="field-shapes"
        type="geojson"
        maxzoom={23}
        data={featureCollection(fieldShapes || [])}
      >
        <Layer
          type="fill"
          // @ts-ignore
          paint={FIELD_STYLE.fillPaint}
        />
        <Layer
          type="line"
          layout={{
            // @ts-ignore
            'line-cap': 'round',
            'line-join': 'round',
          }}
          // @ts-ignore
          paint={FIELD_STYLE.linePaint}
        />
      </Source>
      <Source id="field-points" type="geojson" data={featureCollection(fieldPoints || [])}>
        <Layer
          type="circle"
          // @ts-ignore
          paint={FIELD_STYLE.circlePaint}
        />
      </Source>
      <Source id="overlaps" type="geojson" data={featureCollection(editorOverlaps.overlaps || [])}>
        <Layer
          type="circle"
          filter={['==', ['geometry-type'], 'Point']}
          // @ts-ignore
          paint={{
            'circle-color': '#f00',
          }}
        />
        <Layer
          type="fill"
          filter={['!=', ['geometry-type'], 'Point']}
          // @ts-ignore
          paint={{
            'fill-color': '#f00',
          }}
        />
      </Source>
    </>
  )
}
